import { useEffect, useRef } from "react";
import { useAnalytics } from "../lib/analytics";

export function useTrackPageView(
	eventName: string,
	payload?: Record<string, string>,
) {
	const analytics = useAnalytics();
	const hasTracked = useRef(false);

	useEffect(() => {
		if (!hasTracked.current) {
			hasTracked.current = true;
			analytics.logEvent("page_view", eventName, payload ?? {});
		}
	}, [analytics, eventName, payload]);
}
